import * as R from "ramda";

import { bool, func, number, object } from "prop-types";

import cx from "classnames";

import useMatchMedia from "../../common/useMatchMedia.js";

const propTypes = {
  clearAllFacets: func,
  activeFacets: object,
  facetMenuOpen: bool,
  totalResults: number,
  onFacetClick: func,
  setFacetMenuOpen: func,
};

export const FacetBubbles = (props) => {
  const {
    activeFacets,
    totalResults,
    onFacetClick,
    clearAllFacets,
    facetMenuOpen,
    setFacetMenuOpen,
  } = props;

  //matches bp-medium-min in breakpoints.scss
  const isMedium = useMatchMedia("(min-width: 746px)");

  const bubbles = R.compose(
    R.unnest,
    R.map((item) => {
      const [facetId, values] = item;

      if (isMedium) {
        return values.map((val) => (
          <button
            key={val}
            className="facet-bubbles__remove"
            aria-label="remove facet"
            type="button"
            onClick={() => onFacetClick(facetId, val)}
          >
            {closeIcon}
            <span>{val}</span>
          </button>
        ));
      } else {
        return (
          <button
            className="facet-bubbles__remove"
            aria-label="filters"
            type="button"
            onClick={() => {
              setFacetMenuOpen(true);
              document
                .getElementsByClassName("main-content-wrapper")[0]
                .scrollIntoView({ behavior: "smooth" });
            }}
          >
            <span>Filters ({values.length})</span>
          </button>
        );
      }
    }),
    R.toPairs
  )(activeFacets);

  return activeFacets ? (
    <div className="container--100">
      <div
        className={cx("facet-bubbles", {
          "facet-bubbles--facet-menu-open": facetMenuOpen,
        })}
      >
        {bubbles.length > 0 && (
          <>
            <div className="facet-bubbles__total-results">
              ({totalResults} {totalResults === 1 ? "result" : "results"})
            </div>

            {isMedium ? (
              <div>
                <button
                  onClick={() => clearAllFacets()}
                  className="facet-bubbles__remove"
                  aria-label="clear all facets"
                  type="button"
                >
                  {closeIcon}
                  <span>Clear all</span>
                </button>
                {bubbles}
              </div>
            ) : (
              <div className="facet-bubbles_total-results-list">
                {bubbles}
                <button
                  onClick={() => {
                    clearAllFacets();
                    setFacetMenuOpen(true);
                    document
                      .getElementsByClassName("main-content-wrapper")[0]
                      .scrollIntoView({ behavior: "smooth" });
                  }}
                  className="facet-bubbles__remove"
                  aria-label="clear all facets"
                  type="button"
                >
                  {closeIcon}
                  <span>Clear all</span>
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  ) : null;
};

FacetBubbles.propTypes = propTypes;
export default FacetBubbles;

const closeIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-x"
  >
    <line x1="18" y1="6" x2="6" y2="18"></line>
    <line x1="6" y1="6" x2="18" y2="18"></line>
  </svg>
);
